<template>
  <div>
    <div v-if="!userAgent">
      <!-- banner -->
      <div class="banner">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tab">
        <el-tabs v-model="activeName" @tab-click="tabClick($event,xinwen)">
          <el-tab-pane :label="item.name" v-for="(item,index) in xinwen" :key="index">
            <div class="tabs-title">
              <!-- 三条主体内容 -->
              <div
                class="one"
                @click="details(item.id)"
                v-for="(item,index) in hangye"
                :key="index"
              >
                <div>
                  <img :src="item.image" alt />
                </div>
                <div>{{item.title}}</div>
                <div>{{item.ctime}}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div>
          <!--下面文字内容-->
          <div
            class="content"
            v-for="(item,index) in xinwen2"
            :key="index"
            @click="details(item.id)"
          >
            <div class="num">
              <div>{{item.ctimer}}</div>
              <div>{{item.ctime}}</div>
            </div>
            <div class="t">
              <div class="tit">
                <div>{{item.title}}</div>
                <div>{{item.simple}}</div>
              </div>
              <div class="more">
                <div>
                  <p>MORE</p>
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="page">
          <el-pagination
            layout="prev, pager, next"
            :page-count="msg"
            :page-size="5"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- banner -->
      <div class="banner1">
        <img :src="image" alt />
      </div>
      <!-- tabs -->
      <div class="tab1">
        <el-tabs v-model="activeName" @tab-click="tabClick($event,xinwen)">
          <el-tab-pane :label="item.name" v-for="(item,index) in xinwen" :key="index">
            <div class="tabs-title1">
              <!--三条主体内容-->
              <div
                class="one1"
                @click="details(item.id)"
                v-for="(item,index) in hangye"
                :key="index"
              >
                <div>
                  <img :src="item.image" alt />
                </div>
                <div>{{item.title}}</div>
                <div>{{item.ctime}}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div
          class="content1"
          v-for="(item,index) in xinwen2"
          :key="index"
          @click="details(item.id)"
        >
          <div class="num1">
            <div>{{item.ctimer}}</div>
            <div>{{item.ctime}}</div>
          </div>
          <div class="t1">
            <div class="tit1">
              <div>{{item.title}}</div>
              <div class="msg">{{item.simple}}</div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="page1">
          <el-pagination
            layout="prev, pager, next"
            :page-count="msg"
            :page-size="5"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "News",
  data() {
    return {
      activeName: "0",
      image: "",
      img: [],
      hangye: [],
      image1: "",
      xinwen: [],
      xinwen2: [],
      msg: 0,
      url: "",
      id: "",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 详情
    details(id) {
      this.$router.push(`/newsDetails?id=${id}&activeName=${this.activeName}`);
    },
    tabClick: function (tab, data) {
      var that = this;
      let key = tab.index;
      let id = data[key].id;
      this.$http.get(`news/l_req?id=${id}&page=${0}`).then(function (res) {
        that.xinwen2 = res.data.data;
        that.msg = res.data.msg;
      });
       this.$http.get(`news/cate?id=${id}`).then(function (res) {
        that.hangye = res.data.data;
      });
      // 路由跳转
      this.url = "/news?d=" + tab.name;
      this.$root.newVue.$emit("nav_index", this.url);
      // this.$router.push(url);
    },
    handleCurrentChange(msg) {
      this.geti_pages(msg - 1);
    },
    geti_pages: function (val) {
      var that = this;
      let key = that.activeName;
      let id = that.xinwen[key].id;
      that.$http.get(`news/l_req?id=${id}&page=${val}`).then(function (res) {
        that.xinwen2 = res.data.data;
        that.msg = res.data.msg;
      });
    },
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.query.d);
        this.activeName = this.$route.query.d;
      },
      deep: true,
    },
  },
  mounted() {
    var that = this;
    that.activeName = this.$route.query.d;
    that.$http.get("images/news").then(function (res) { //轮播
      that.image = res.data.data.image;
    });
    that.$http.get("news/index").then(function (res) {//tabs
      that.xinwen = res.data.data;
      let id = that.xinwen[that.$route.query.d].id;
      that.$http.get(`news/l_req?id=${id}&page=${0}`).then(function (res) { //下面文字加分页
        that.xinwen2 = res.data.data;
        that.msg = res.data.msg;
        console.log('page',res.data.data);
      });
        that.$http.get(`news/cate?id=${id}`).then(function (res) {
        that.hangye = res.data.data;
        console.log('hangye',res.data.data);
      });
    });
  },
};
</script>
<style scoped lang="scss">
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.tab {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  .tabs-title {
    display: grid;
    // justify-content: space-between;
    justify-content: space-between;
    grid-template-columns: repeat(3, 31%);
    margin: 0 auto;
    margin-top: 5%;
    flex-wrap: wrap;
    width: 100%;
    .one {
      width: 100%;
      background: #fff;
      padding-bottom: 2rem;
      border: 1px solid #f5f5f5;
      margin-bottom: 3rem;
      div:first-child {
        width: 100%;
        img {
          width: 100%;
        }
      }
      div:nth-child(2) {
        font-size: 14px;
        color: #333;
        font-weight: bold;
        padding-left: 1rem;
        padding-top: 1rem;
      }
      div:nth-child(3) {
        font-size: 15px;
        color: #999;
        padding-left: 1rem;
        padding-top: 0.3rem;
        margin-top: 1rem;
      }
    }
    .one:hover {
      border: 1px solid #43ae85;
      cursor: pointer;
      div:nth-child(2) {
        color: #43ae82;
      }
    }
  }
  .content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    margin-top: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
    .num {
      width: 75px;
      height: 75px;
      border: 1px solid #3daf81;
      border-radius: 5px;
      text-align: center;
      line-height: 2rem;
      div:first-child {
        font-size: 35px;
        font-weight: bold;
        color: #43ae82;
        padding-top: 0.5rem;
      }
      div:nth-child(2) {
        font-size: 14px;
        color: #999;
      }
    }
    .t {
      width: 95%;
      display: flex;
      .tit {
        padding-left: 1rem;
        width: 80%;
        cursor: pointer;
        div:first-child {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          margin-top: 0.5rem;
        }
        div:nth-child(2) {
          color: #333;
          font-size: 14px;
          margin-top: 1rem;
        }
      }
      .more {
        width: 20%;
        margin: 0 auto;
        text-align: center;
        div {
          font-size: 14px;
          color: #333;
          margin-top: 1.3rem;
        }
      }
    }
    .t:hover {
      cursor: pointer;
      .tit div:first-child {
        color: #43ae85;
      }
      .more div {
        color: #43ae82;
      }
    }
  }
  .page {
    width: 20%;
    margin: 0 auto;
    padding-top: 2rem;
    padding-bottom: 5rem;
  }
}
button {
  outline: none;
}
.banner1 {
  width: 100%;
  img {
    width: 100%;
    height: 7rem;
  }
}
.tab1 {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  .tabs-title1 {
    flex-wrap: wrap;
    width: 100%;
    .one1 {
      background: #fff;
      padding-bottom: 1rem;
      border: 1px solid #f5f5f5;
      margin-bottom: 1rem;
      div:first-child {
        width: 100%;
        img {
          width: 100%;
        }
      }
      div:nth-child(2) {
        font-size: 14px;
        color: #333;
        font-weight: bold;
        padding-left: 1rem;
        padding-top: 1rem;
      }
      div:nth-child(3) {
        font-size: 15px;
        color: #999;
        padding-left: 1rem;
        padding-top: 0.3rem;
        margin-top: 1rem;
      }
    }
    .one1:hover {
      border: 1px solid #43ae85;
      div:nth-child(2) {
        color: #43ae82;
      }
    }
  }
  .content1 {
    width: 90%;
    margin: 0 auto;
    display: flex;
    margin-top: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
    .num1 {
      width: 75px;
      height: 75px;
      border: 1px solid #3daf81;
      border-radius: 5px;
      text-align: center;
      line-height: 2rem;
      div:first-child {
        font-size: 35px;
        font-weight: bold;
        color: #43ae82;
        padding-top: 0.5rem;
      }
      div:nth-child(2) {
        font-size: 14px;
        color: #999;
      }
    }
    .t1 {
      width: 75%;
      display: flex;
      .tit1 {
        padding-left: 1rem;
        margin-top: 3%;
        div:first-child {
          font-size: 12px;
          color: #333;
          font-weight: bold;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /*后面的5是设置显示几行*/
          margin: 0 auto;
        }
        .msg {
          color: #333;
          font-size: 11px !important;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3; /*后面的5是设置显示几行*/
          margin: 0 auto;
          padding-top: 0.4rem;
          line-height: 0.9rem;
        }
      }
    }
    .t1:hover {
      .tit div:first-child {
        color: #43ae85;
      }
      .more div {
        color: #43ae82;
      }
    }
  }
  .page1 {
    width: 50%;
    margin: 0 auto;
    text-align: center;
    padding-top: 2rem;
    padding-bottom: 1rem;
  }
}
</style>
<style>
.tab .el-tabs__item {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
.tab .el-tabs__content {
  overflow: hidden;
  position: relative;
  top: 0;
  bottom: 0;
  margin-top: -1%;
  padding-bottom: 2rem;
}
.tabs .tabs-title .title {
  width: 80%;
  margin: 0 auto;
  padding-top: 4rem;
}
.tabs .tabs-title,
.tabs .content {
  width: 80%;
}
.el-tabs__item:hover {
  color: #43ae82;
  cursor: pointer;
}

.tab .el-pager li {
  min-width: 28px;
  border: 1px solid rgba(212, 212, 212, 1);
  border-radius: 50%;
  background: #43ae82;
  color: #666666;
  margin: 0 10px;
  background: rgba(245, 245, 245, 1);
  font-weight: normal;
}
.tab .el-pager li.active {
  background: #43ae82;
  color: white;
}
.tab .el-pagination button:disabled {
  color: #666666;
  cursor: not-allowed;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: rgba(245, 245, 245, 1);
  min-width: 28px;
  border-radius: 50%;
}

.tab .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: center center no-repeat rgba(245, 245, 245, 1);
  background-size: 16px;
  cursor: pointer;
  color: #666666;
  margin: 0;
  min-width: 28px;
  border-radius: 50%;
  border: 1px solid #ddd;
}
.el-pagination button:hover {
  color: #43ae82;
}
.tab1 .el-tabs__nav-scroll {
  padding-bottom: 6px;
  height: 3rem;
  line-height: 3rem;
}
.tab1 .el-tabs__item {
  font-weight: bold;
}
.tab1 .el-tabs__nav-scroll,
.tab1 .el-tab-pane {
  width: 90%;
  margin: 0 auto;
}
.tab1 .el-pager li.active {
  color: #fff !important;
  border-radius: 50%;
  background: #43ae82;
}
.tab1 .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: center center no-repeat rgba(245, 245, 245, 1);
  background-size: 16px;
  cursor: pointer;
  color: #666666;
  margin: 0;
  min-width: 28px;
  border-radius: 50%;
  border: 1px solid #ddd;
}
.tab1 .el-dialog,
.el-pager li {
  border: 1px solid #ddd;
  border-radius: 50%;
}
</style>